import { AnswerPathTreeNode } from '@zinnia/form-engine-sdk';

import { NodeIds } from '../../../../nodeIds';

export const anyOtherRespiratoryDisorder: AnswerPathTreeNode = {
  path: 'anyOtherRespiratoryDisorder',
  children: [{ path: 'details', nodeId: NodeIds.healthInsuredAnyOtherRespiratoryDisorderDetails }],
};
